import { ArrowUpRight } from 'lucide-react';
import { SERVICE_CARD } from '@/lib/testIds';
import { Link } from 'react-router-dom';

export default function ServiceCard({ service, variant = 'default' }) {
  const Icon = service.icon;
  return (
    <Link
      to="/services"
      data-testid={SERVICE_CARD(service.slug)}
      className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0B1221]/60 backdrop-blur-xl p-7 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-400/30 hover:shadow-[0_0_30px_rgba(34,211,238,0.12)]"
    >
      <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-cyan-400/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="relative flex items-start justify-between mb-6">
        <div className="w-12 h-12 grid place-items-center rounded-xl border border-cyan-400/20 bg-cyan-400/5 text-cyan-300">
          <Icon className="w-6 h-6" strokeWidth={1.5} />
        </div>
        <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-cyan-300 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
      </div>
      <h3 className="font-heading text-xl font-medium leading-snug mb-2.5">{service.title}</h3>
      <p className="text-sm text-white/60 leading-relaxed">{service.short}</p>
      {variant === 'detailed' && service.points && (
        <ul className="mt-5 space-y-2 border-t border-white/5 pt-5">
          {service.points.map((p, i) => (
            <li key={i} className="flex items-start gap-2 text-xs text-white/60">
              <span className="mt-1.5 w-1 h-1 rounded-full bg-cyan-400" />
              {p}
            </li>
          ))}
        </ul>
      )}
    </Link>
  );
}
